import React, { useRef } from 'react';
import { Avatar } from '@mantine/core';
import noPreviewImage from '../../../../assets/images/NoPreview.png';
import { UsageRightRequest } from '../types';
import { formatNumber } from '../../../../utils/formattingUtils';
import styles from '../../../../styles/usageRights.module.css';
import instagramFilledIcon from '../../../../assets/images/instagram-filled.png';

interface UsageRightImageContainerProps {
  request: UsageRightRequest;
  style?: React.CSSProperties;
}

function UsageRightImageContainer({ request, style }: UsageRightImageContainerProps) {
  const img = useRef<HTMLImageElement>(null);

  const onImageLoadError = () => {
    if (img?.current) {
      img.current.src = noPreviewImage;
    }
  };

  return (
    <div className={styles.usageRightImageViewerContainer} style={style}>
      <div className={styles.topContainer}>
        <div className={styles.cardTopProfileContainer}>
          <div className={styles.cardTopAvatarWrapper}>
            <Avatar size={30} radius="xl" src={request.profile?.imageUrl} />
          </div>
          <div
            role="presentation"
            className={styles.profileInfoSection}
            onClick={() => window.open(request?.entityUrl)}
          >
            <div className={styles.profileInfoSectionTitle}>
              <img width={18} height={18} src={instagramFilledIcon} alt="" />@{request.profile?.username}
            </div>
            <div className={styles.profileInfoSectionSubTitle}>
              {formatNumber(request.profile?.followers)} followers
            </div>
          </div>
        </div>
      </div>
      <div className={styles.gradientOverlayTop} />
      <div className={styles.gradientOverlayBottom} />
      <img
        src={request.thumbnail || noPreviewImage}
        style={{ width: '100%' }}
        ref={img}
        alt="No Preview"
        onError={() => onImageLoadError()}
        loading="lazy"
      />
    </div>
  );
}

export default UsageRightImageContainer;
